import type { ClientOverviewRepository } from "../repositories/ClientOverviewRepository";
import type { RecentRevenueActivityEntity } from "../entities/RecentRevenueActivityEntity";
import type { GetRecentRevenueActivityParams } from "../repositories/ClientOverviewRepository";

export class GetRecentRevenueActivityUseCase {
  constructor(private readonly repository: ClientOverviewRepository) {}

  async execute(params: GetRecentRevenueActivityParams): Promise<RecentRevenueActivityEntity> {
    return this.repository.getRecentRevenueActivity(params);
  }
}
